import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppResponse } from '@data/app/response';
import { ProductionEntity, Project } from '@data/project/project';
import { environment } from '@environments/environment';
import { ApiPaths } from '@mpg-core/constants/api-paths.enum';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProdEntityService {

  constructor(private http: HttpClient) { }

  getProdEntityList(): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.getProductionEntityList).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  softDeleteProdEntity(payload:ProductionEntity): Observable<any>{
    return this.http.post<any>(environment.apiUrl+ ApiPaths.softDeleteProdEntity, payload ).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  updateProdEntity(payload:ProductionEntity): Observable<any>{
    return this.http.post<any>(environment.apiUrl+ ApiPaths.updateProductionEntity, payload ).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  doesEntityHaveProject(productionEntityId:number): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.doesEntityHaveProject+"/"+productionEntityId).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  getDeleteStatusOptions() {
    return deleteStatusOptions;
}
  
}

const deleteStatusOptions: any[] = [
  { id: "Y", name: "Inactive", value: true },
  { id: "N", name: "Active", value: false },
];
